import React, { useState, useEffect } from "react";
import "./style.scss";
import LockIcon from "../../../assets/icons/lock.svg";
import { useDispatch, useSelector } from "react-redux";
import { deAuthenticate } from "../../../store/reducers/authSlice";
import { PURGE_Brand } from "../../../store/reducers/brandReducer";
import { clearPersistedData } from "../../../store/configureStore";

function SessionExpiredModal({ open: controlledOpen }) {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const idToken = useSelector((state) => state.auth?.idToken);
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);

  const handleLoginAgain = () => {
    setIsOpen(false);
    const currentPath = window.location.pathname + window.location.search;
    const savedRedirect =
      sessionStorage.getItem("redirectAfterLogin") ||
      (currentPath !== "/signin" && !currentPath.startsWith("/signin")
        ? currentPath
        : "/");

    dispatch(deAuthenticate());
    dispatch(PURGE_Brand());

    localStorage.clear();
    sessionStorage.clear();

    if (savedRedirect && savedRedirect !== "/signin") {
      sessionStorage.setItem("redirectAfterLogin", savedRedirect);
    }

    clearPersistedData();
    window.location.href = "/signin";
  };

  useEffect(() => {
    if (controlledOpen !== undefined) {
      setIsOpen(controlledOpen);
    }
  }, [controlledOpen]);

  // Listen for session-expired events dispatched across the app
  useEffect(() => {
    const onSessionExpired = () => {
      const currentPath = window.location.pathname + window.location.search;
      if (currentPath !== "/signin" && !currentPath.startsWith("/signin")) {
        sessionStorage.setItem("redirectAfterLogin", currentPath);
        setIsOpen(true);
      }
    };

    window.addEventListener("session-expired", onSessionExpired);
    return () => {
      window.removeEventListener("session-expired", onSessionExpired);
    };
  }, []);

  // Periodic check for token expiration while user is idle
  useEffect(() => {
    if (!isAuthenticated || !idToken) return;

    const checkTokenExpiry = () => {
      try {
        const parts = idToken.split(".");
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          if (payload?.exp && Date.now() >= payload.exp * 1000) {
            const currentPath = window.location.pathname + window.location.search;
            if (currentPath !== "/signin" && !currentPath.startsWith("/signin")) {
              sessionStorage.setItem("redirectAfterLogin", currentPath);
              setIsOpen(true);
            }
          }
        }
      } catch (e) {}
    };

    checkTokenExpiry();
    const interval = setInterval(checkTokenExpiry, 15000);
    return () => clearInterval(interval);
  }, [idToken, isAuthenticated]);

  if (!isOpen) return null;

  return (
    <div className="session_expired_modal_overlay">
      <div className="session_expired_modal_container">
        <div className="session_expired_modal_container_top">
          <div className="icon_badge">
            <img src={LockIcon} alt="Session Expired" />
          </div>
        </div>

        <div className="session_expired_modal_container_bottom">
          <h1>Session Expired</h1>
          <p className="session_expired_message">
            You have been logged out due to inactivity.
          </p>

          <button
            className="session_expired_login_btn"
            onClick={handleLoginAgain}
          >
            Log In Again
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionExpiredModal;
